import React from 'react';

const PrivacyPolicyText = () => {
    return (
        <section className="about_section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <figure>
                            <figcaption className="about_content">
                                <h1>Политика конфиденциальности</h1>
                                <p className="about_content_left">
                                    <h4>1. Общие положения</h4>
                                    Настоящая политика конфиденциальности регулирует порядок
                                    обработки и хранения персональных данных пользователей на сайте holz-city.ru (далее
                                    — «Сайт»).

                                    <h4>2. Сбор и обработка персональных данных</h4>
                                    Мы собираем и обрабатываем следующие данные:
                                    <ul>
                                        <li>Имя</li>
                                        <li>Номер телефона</li>
                                        <li>Email</li>
                                    </ul>
                                    Эти данные предоставляются пользователем добровольно при оформлении заказа или
                                    отправке запроса на обратную связь.
                                    <h4>3. Использование данных</h4>
                                    Собранные данные используются исключительно для:
                                    <ul>
                                        <li>Оформления и обработки заказов;</li>
                                        <li>Связи с пользователем по вопросам заказа или консультации.</li>
                                    </ul>
                                    <h4>4. Сбор технических данных</h4>
                                    Для улучшения качества сервиса и анализа посещаемости Сайта используются следующие
                                    инструменты:
                                    <ul>
                                        <li>Яндекс.Метрика</li>
                                        <li>Google Analytics</li>
                                    </ul>
                                    Эти системы могут собирать анонимные данные о действиях посетителей,
                                    включая информацию о просмотренных страницах, IP-адресах и источниках трафика.
                                    <h4>5. Передача данных третьим лицам</h4>
                                    Мы не передаем персональные данные третьим лицам,
                                    за исключением случаев, предусмотренных законодательством Российской Федерации.
                                    <h4>6. Защита данных</h4>
                                    Мы принимаем все необходимые организационные и технические меры для защиты ваших
                                    данных от несанкционированного доступа, изменения или уничтожения.
                                    <h4>7. Права пользователя</h4>
                                    Вы имеете право:
                                    <ul>
                                        <li>Узнать, какие персональные данные о вас хранятся;</li>
                                        <li>Потребовать их обновления, исправления или удаления.</li>
                                    </ul>
                                    <h4>8. Контактная информация</h4>
                                    Если у вас возникли вопросы по поводу данной политики конфиденциальности,
                                    вы можете связаться с нами по адресу: 89852223295@mail.ru
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicyText;